<breadcrumbs
  [breadcrumbs]="[{ label: 'ADMIN', url: '/admin' }, { label: 'FORMS' }]"
></breadcrumbs>

<page-header title="FORMS"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('filtered')"
  [itemsPerPage]="getQueryParam('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getQueryParam('page')"
  (onPageChange)="handlePageChange($event)"
  (onPageSizeChange)="handlePageSizeChange($event)"
  (onSort)="handleSort($event)"
  [sort]="getQueryParam('sort')"
  [orderBy]="getQueryParam('order_by')"
  [columns]="columns"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        [routerLink]="['create']"
        class="button is-small is-info"
        translationEditableDirective="CREATE_FORM"
        >{{ 'CREATE_FORM' | translate }}</a
      >
    </div>
  </ng-template>

  <ng-template #addonRight>
    <form>
      <input
        [translationEditableModalDirective]="['SEARCH']"
        class="input is-small"
        type="text"
        (input)="handleFilterChange($event)"
        [value]="getQueryParam('keyword')"
        name="keyword"
        [placeholder]="'SEARCH' | translate"
      />
    </form>
  </ng-template>

  <ng-template let-row="row" #actionsColumn>
    <div class="buttons m-0">
      <button
        class="button is-primary is-small"
        (click)="preview(row)"
        translationEditableDirective="PREVIEW"
      >
        {{ 'PREVIEW' | translate }}
      </button>
      <button
        class="button is-info is-small"
        (click)="duplicate(row)"
        translationEditableDirective="DUPLICATE"
      >
        {{ 'DUPLICATE' | translate }}
      </button>
      <a
        [routerLink]="[row.get('id'), 'update']"
        class="button is-small"
        translationEditableDirective="UPDATE"
        >{{ 'UPDATE' | translate }}</a
      >
      <alert
        #deleteAlert
        (confirm)="deleteUser(row.get('id'))"
        titleTrnKey="ARE_YOU_SURE"
        textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
      />
      <button
        class="button is-danger is-small"
        (click)="deleteAlert.fire()"
        translationEditableDirective="DELETE"
      >
        {{ 'DELETE' | translate }}
      </button>
    </div>
  </ng-template>
</app-table>

<div class="modal" [ngClass]="{ 'is-active': isPreviewOpen }">
  <div class="modal-background"></div>
  <div class="modal-card" style="width: 80vw; max-width: 1000px">
    <header class="modal-card-head">
      <p class="modal-card-title m-0" translationEditableDirective="PREVIEW">
        {{ 'PREVIEW' | translate }}
      </p>
      <button
        class="delete"
        aria-label="close"
        (click)="isPreviewOpen = false"
      ></button>
    </header>
    <section class="modal-card-body">
      <form-preview
        [rows]="previewForm"
        [activeForm]="previewForm"
        *ngIf="previewForm"
      ></form-preview>

      <ng-lottie
        *ngIf="!previewForm"
        [options]="options"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 300px;
        "
        width="280px"
      ></ng-lottie>
    </section>
  </div>
</div>
